import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', textAlign: 'center' }}>
      <div>
        <div style={{ fontFamily: "'Sora',sans-serif", fontSize: '96px', fontWeight: 800, background: 'var(--grad)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', lineHeight: 1, marginBottom: '16px' }}>
          404
        </div>
        <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: '28px', fontWeight: 700, color: '#111', marginBottom: '12px' }}>
          Page introuvable
        </h1>
        <p style={{ fontSize: '15px', color: '#666', lineHeight: 1.7, maxWidth: '420px', margin: '0 auto 32px' }}>
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn-primary" style={{ fontSize: '14px', padding: '12px 24px' }}>
            Retour à l'accueil →
          </Link>
          <Link to="/contact" style={{ fontFamily: "'Sora',sans-serif", fontSize: '14px', fontWeight: 500, padding: '12px 20px', background: 'transparent', border: '1px solid #e0e0e0', color: '#555', borderRadius: '9px', textDecoration: 'none' }}>
            Nous contacter
          </Link>
        </div>
      </div>
    </main>
  );
}
